export default __webpack_public_path__ + "static/media/binary-exploitation.1ff19a59.jpg";